export const NAVIGATOR_GO_PANEL = '@navigator/go-panel';
export const NAVIGATOR_SHOW_POPOUT = '@navigator/show-popout';
